/** Row `bookable` string: "true" = room assignment, "false" = standalone (B′). */
export const EQUIPMENT_ROLE_ROOM = "true" as const;
export const EQUIPMENT_ROLE_STANDALONE = "false" as const;

export type EquipmentRoleBookable = typeof EQUIPMENT_ROLE_ROOM | typeof EQUIPMENT_ROLE_STANDALONE;

export function isStandaloneEquipmentRole(bookable: string | undefined): boolean {
  return bookable === EQUIPMENT_ROLE_STANDALONE;
}

/**
 * Prefer `standaloneBookable` from the API. Both-false / missing standalone → room.
 * Do not treat legacy `bookable === 0` alone as standalone.
 */
export function equipmentRoleFromApi(flags: {
  bookable?: number | boolean | null;
  standaloneBookable?: number | boolean | null;
}): EquipmentRoleBookable {
  if (flags.standaloneBookable === 1 || flags.standaloneBookable === true) {
    return EQUIPMENT_ROLE_STANDALONE;
  }
  return EQUIPMENT_ROLE_ROOM;
}

/** XOR payload for BE B′: exactly one of bookable / standaloneBookable. */
export function equipmentRoleApiFlags(bookable: string | undefined): {
  bookable: 0 | 1;
  standaloneBookable: 0 | 1;
} {
  if (isStandaloneEquipmentRole(bookable)) {
    return { bookable: 0, standaloneBookable: 1 };
  }
  return { bookable: 1, standaloneBookable: 0 };
}
